<template>
    <div>
        <el-dialog v-dialogDrag  :visible.sync="openComment" class="comment-dialog" :modal="false">
            <div class="flow">
                <div slot="title" class="dialog-header">
                    <img class="collect-icon" src="@/assets/images/bookIcons/commit3.png" alt="">
                    <div class="collect-title">评论</div>
                    <div class="line-area"></div>
                </div>
                <div class="middle" v-loading="loading">
                    <div v-for="(item, index) in commentList" :key="index" class="comment-box">

                        <div class="comment-ava">
                            <el-avatar :size="39" :src="item.src"></el-avatar>
                        </div>
                    <div class="comment">
                        <div class="comment-name">{{ item.userName }}</div>
                        <div class="comment-content">{{ item.content }}</div>
                        <div class="comment-detail">
                            <div>{{ item.createTime }}</div>
                            <div class="comment-delete" @click="deleteComment(item.id)">
                                <i class="el-icon-delete"></i>
                            </div>
                            <div class="reply" @click="showReplyInput(index)">回复</div>
                        </div>
                        <div v-show="replyIndex == index">
                            <div class="input">
                                <el-input ref="input" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                                    placeholder="请输入评论" v-model.trim="textChildren">
                                </el-input>
                            </div>
                            <div class="button-box">
                                <el-button class="confirm" :disabled="noteRead" @click="replyComment(item)">回复评论</el-button>
                            </div>
                        </div>
                        <template v-if="item.children">
                        <div v-for=" (child,index) in item.children.slice(0,1)" :key="index" class="comment-box2"
                            v-show="item.children.length <= 1 || !item.isShow">
                            <el-avatar :size="20" :src="item.src"></el-avatar>
                            <div class="comment2">
                                <div>
                                    <div class="comment-name">{{ child.userName }}</div>
                                    <div class="comment-content2">{{ child.content }}</div>
                                </div>
                                <div class="comment-detail2">
                                    <div>{{ child.createTime }}</div>
                                    <div class="comment-delete2" @click="deleteComment(child.id)">
                                        <i class="el-icon-delete"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-for=" child in item.children" :key="child.id" class="comment-box2"
                            v-show="item.isShow">
                            <el-avatar :size="20" :src="child.src"></el-avatar>
                            <div class="comment2">
                                <div>
                                    <div class="comment-name">{{ child.userName }}</div>
                                    <div class="comment-content2">{{ child.content }}</div>
                                </div>
                                <div class="comment-detail2">
                                    <div>{{ child.createTime }}</div>
                                    <div class="comment-delete2" @click="deleteComment(child.id)">
                                        <i class="el-icon-delete"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div v-if="item.children.length > 1" class="comment-more" @click="viewAll(index)">
                            {{ showIndex!=index ? `查看全部 ${item.children.length} 条回复` : `收起` }}
                        </div> -->
                        <div v-if="item.children.length > 1">
                            <div v-if="!item.isShow" class="comment-more" @click="changeShow(item)">
                                共{{ item.children.length }}条回复，点击查看
                            </div>
                            <div v-else class="comment-more" @click="changeShow(item)"> 收起</div>
                        </div>
                    </template>
                    </div>
                    </div>
                    </div>

                <div slot="footer" class="dialog-footer">
                <div class="input">
                    <el-input ref="input" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入评论"
                        v-model.trim="textarea">
                    </el-input>
                </div>
                <div class="button-box">
                    <el-button class="confirm" @click="addComment(0,textarea)" :disabled="noteRead">添加评论</el-button>
                </div>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'RetrieveDialogComment',
  props: {
    openComment: {
      type: Boolean,
      required: true
    },
    bookId: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    noteRead: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    openComment () {
      this.$emit('closeComment', false)
    }
  },
  data () {
    return {
      commentList: [],
      isMore: false,
      textChildren: '',
      textarea: '',
      showIndex: -1,
      replyIndex: -1,
      loading: false
    }
  },
  mounted () {
    this.getComment()
    console.log('noteRead', this.noteRead)
  },
  methods: {
    getComment () {
      this.loading = true
      //   let params = new URLSearchParams()
      let url = 'retrieve/comment/getAllCommentInPageNumByBookId?bookId=' +
      this.bookId + '&pageNum=' + this.currentPage + "&order='create_time'&orderMethod='DESC'"
      //   params.append('bookId', this.bookId)
      //   params.append('pageNum', this.currentPage)
      //   params.append('order', 'create_time')
      //   params.append('orderMethod', 'DESC')
      this.$http.get(url).then((res) => {
        console.log('resc', res.data.data.CommentList)
        if (res.status === 200 && res.data.status === 200) {
          var tempCommentList = res.data.data.CommentList
          tempCommentList.forEach(item => {
            let url = '/retrieve/user/getAvatar'
            let params = { userId: item.userId }
            this.$http.get(url, { params }).then(res => {
              let avatarUrl = 'data:image/jpg;base64,' + res.data.data
              this.$set(item, 'src', avatarUrl)
            })
            if (item.children) {
              item.children.forEach(child => {
                let url = '/retrieve/user/getAvatar'
                let params = { userId: child.userId }
                this.$http.get(url, { params }).then(res => {
                  let avatarUrl = 'data:image/jpg;base64,' + res.data.data
                  this.$set(child, 'src', avatarUrl)
                })
              })
            }
          })
          setTimeout(() => {
            this.commentList = tempCommentList
            this.loading = false
          }, 100)

          this.$forceUpdate()
        } else {
          this.loading = false
          this.$message({
            type: 'error',
            message: res.data
          })
        }
      })
    },
    changeShow (item) {
      if (!item.isShow) {
        this.$set(item, 'isShow', false)
        item.isShow = !item.isShow
        console.log('1', item.isShow)
        this.$forceUpdate()
      } else {
        item.isShow = !item.isShow
        console.log('2', item.isShow)
        this.$forceUpdate()
      }
    },
    addComment (id, text) {
      if (!text) {
        this.$message({
          type: 'error',
          message: '评论内容不能为空'
        })
      } else {
        let params = new URLSearchParams()
        let url = 'retrieve/comment/addComment'
        params.append('userId', localStorage.getItem('userId'))
        params.append('bookId', this.bookId)
        params.append('pageNum', this.currentPage)
        params.append('content', text)
        params.append('parentId', id)
        this.$http.post(url, params).then((res) => {
          if (res.status == 200 && res.data.status == 200) {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.textChildren = ''
            this.textarea = ''
            this.getComment()
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
        })
      }
    },
    getAvatar (id) {
      this.$http({
        method: 'get',
        url: '/retrieve/user/getAvatar?userId=' + id,
        // 例:{uploadUrl:uploadUrl},传入ofd格式的下载文件url
        responseType: 'blob' // 设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置，否则pdf会展示空白！！！
      }).then(res => {
        const binaryData = []
        binaryData.push(res.data)
        const url = window.URL.createObjectURL(
          new Blob(binaryData, { type: 'image/jpg' })
        )
        var image = url
        return image
        // this.viewVisible = true // 当前页弹框打开
        // 新页面打开
        //   window.open(url)
        // this.$forceUpdate()
      }).catch(function (error) {
        this.image = ''
        console.log(error)
      })
    },
    deleteComment (id) {
      console.log('zz')
      let url = 'retrieve/comment/deleteCommentById?id=' + id
      this.$http.delete(url).then((res) => {
        if (res.status === 200 && res.data.status === 200) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getComment()
        } else {
          this.$message({
            type: 'error',
            message: res.data
          })
        }
      })
    },
    // 收起/展开
    viewAll (index) {
      this.showIndex = index
    },
    hide () {
      this.showIndex = -1
    },
    // 打开回复框
    showReplyInput (index) {
      this.replyIndex = this.replyIndex === index ? -1 : index
    },
    // 提交回复
    replyComment (item) {
      this.replyIndex = -1
      this.addComment(item.id, this.textChildren)
    }
  }
}
</script>

<style scoped>
.comment-dialog>>>.el-dialog {
    width: 370px !important;
    height: 580px !important;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #F7F6F5;
    margin-right: 160px;
    text-align: left;
    overflow: auto;
    /* overflow-x: hidden;
    overflow-y: auto; */
}
.comment-dialog >>> .el-dialog__headerbtn {
    top: 5px !important;
    right: 4px;
    background: url('../assets/images/bookIcons/close.png') left no-repeat;
    background-size: cover;
    font-family:"Avenir", Helvetica, Arial, sans-serif;
    width:20px;
    height: 20px;
}
.comment-dialog ::-webkit-scrollbar {
  background-color: #f5eee8;
  width: 4px;
}

.comment-dialog ::-webkit-scrollbar-thumb {
  background-color: #9e5c1d;
}
.collect-icon {
    width: 16.19px;
    height: 15.79px;
}

.comment-dialog>>>.el-dialog__header {
    padding: 15px 0 0 16px;
}

.comment-dialog>>>.el-dialog__body {
    padding-top: 0;
    padding-bottom: 15px;
}

.collect-title {
    font-size: 18px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    color: #9E5C1D;
    display: inline;
    margin: 0 0 13px 10px;
    bottom: 13px;
}

.line-area {
    width: 115px;
    margin-top: 12px;
    border-bottom: 1px solid #9E5C1D;
}

.comment-box {
    display: flex;
    flex-direction: row;
    padding-top: 20px;
}
.middle{
    height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
}
.comment-box2 {
    margin-top: 9px;
    display: flex;
    flex-direction: row;
}

.comment {
    width: 250px;
    margin-left: 13px;
    display: inline;
}

.comment-name {
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #9E5C1D;
    line-height: 0px;
    display: inline;
}

.comment-content {
    width: 250px;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #634C37;
    margin-top: 14px;
}

.comment-detail {
    margin-top: 10px;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #A5A5A5;
    display: flex;
}

.comment-delete {
    display: inline;
    margin-left: 50px;
    margin-right: 17px;
    cursor: pointer;
}

.comment2 {
    width: 220px;
    margin-left: 13px;
    display: inline;
}

.comment-content2 {
    width: 250px;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #634C37;
    margin-left: 14px;
    display: inline;
}

.comment-detail2 {
    margin-top: 6px;
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #A5A5A5;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}

.comment-delete2 {
    display: inline;
    margin-right: 10px;
    cursor: pointer;
}

.comment-more {
    margin-top: 5px;
    margin-left: 37px;
    text-decoration: underline;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #A5A5A5;
    cursor: pointer;
}

.input {
    margin-top: 12px;
}

.input>>>.el-textarea__inner {
    background: rgba(99, 76, 55, 0.06);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid rgba(99, 76, 55, 0.09);
}

.button-box {
    display: flex;
    justify-content: flex-end;
}

.confirm {
    width: 108px;
    height: 34px;
    background: #9E5C1D;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 0;
    padding: 0;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 200;
    color: #FFFFFF;
    cursor: pointer;
    margin-top: 6px;
}

.reply {
    cursor: pointer;
}
.comment-dialog>>>.el-dialog__footer {
    position: absolute;
    bottom: 9px;
    padding: 0 10px ;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveDialogComment.vue